<template>
  <el-dialog
    id="app"
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_Parter')+'-'+$t('queryJob.AirlineInformation')"
    width="800px"
    :close-on-click-modal="false"
    append-to-body
    class="app-main-inner"
    @close="closeHandler()"
  >
    <div
      class="app-main-inner-row row-grid"
      style="min-height:350px;padding:0"
    >
      <cargo-ag-grid
        config-module="1900001"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :show-side-bar="false"
        :row-data="rowData"
        style="width:100%;height:350px;"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
    <div style="text-align: right;">
      <el-button no="1" type="primary" style="flex-grow: 1" :disabled="isEdit" @click="okHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button no="2" type="danger" style="flex-grow: 1" :disabled="isEdit" @click="closeHandler">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'MawbInfoDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    items: { type: Array, default: null },
    action: { type: String, required: true }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        onCellFocused: event => {
          this.selectedRowIndex = event.rowIndex
        },
        context: {
          componentParent: this
        },
        suppressRowClickSelection: false,
        singleClickEdit: true
      },
      gridParams: {},
      gridApi: null,
      selectedRowIndex: -1,
      rowData: []
    }
  },
  computed: {
    selectedRow() {
      return this.rowData[this.selectedRowIndex]
    },
    isEdit() {
      return this.action !== 'look'
    },
    columnDefs() {
      return [
        { headerName: 'Office', field: 'branchId', width: 200, colId: 'branchId',
          cellRenderer: (params) => {
            return ColumnUtils.officeLabelFunc(params.value)
          }
        },
        { headerName: 'Scheme Name', field: 'schemeName', width: 200, colId: 'schemeName' },
        { headerName: 'IATA Code', field: 'iataCode', width: 200, colId: 'iataCode' },
        { headerName: 'Account No', field: 'accountNo', width: 200, colId: 'accountNo' },
        { headerName: 'Insured Amount', field: 'insuredAmount', width: 200, colId: 'insuredAmount' },
        { headerName: 'Issued By', field: 'issuedBy', width: 200, colId: 'issuedBy' },
        { headerName: 'Carrier Agent City', field: 'carrierAgentCity', width: 200, colId: 'carrierAgentCity' },
        { headerName: 'Account Info', field: 'accountInfo', width: 200, colId: 'accountInfo' },
        { headerName: 'Handling Info', field: 'handingInfo', width: 200, colId: 'handingInfo' }
      ]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.rowData = this.items
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    okHandler() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      this.$emit('selectCallBack', this.selectedRow)
      this.innerVisible = false
    },
    closeHandler() {
      this.innerVisible = false
    }
  }
}
</script>

<style lang="scss">
</style>
